import { use } from 'react';

import { AppInsightsContext } from './AppInsightsProvider';

export const useAppInsightsEvents = () => {
	return use(AppInsightsContext);
};
